import React, { JSX } from "react";
interface Props {
    children?: React.ReactNode;
}
export const AppWrapper = (props: Props): JSX.Element => {
    return (
        <section className={"l-app"}>
            <main className="l-app__content">{props.children}</main>
        </section>
    );
};
